import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import {
  getAbonneInfo_secure,
  modifierMotDePasse_secure,
} from "../../../services/abonne/AbonneRequest";

const MotDePasse = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [lastPassword, setLastPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const changePassword = () => {
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const data = {
      newPassword: newPassword,
      numero: "0506695110",
      password: lastPassword,
      passwordConfirm: confirmPassword,
    };

    modifierMotDePasse_secure(data)
      .then((res) => {
        setLoading(false);
        setLastPassword('')
        setNewPassword('')
        setConfirmPassword('')
        setErrorMessage("");
        setSuccessMessage("Mot de passe modifié avec succès");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err.response.data.donnee);
        setSuccessMessage('')
      });
  };

  useEffect(() => {
    setErrorMessage("");
    setSuccessMessage("");
    getAbonneInfo_secure()
      .then((res) => {
        setLoading(false);
        setUser(res.data.donnee);
      })
      .catch((err) => {
        setLoading(false);
        console.log("api error", err.message);
      });
  }, []);

  return (
    <div className="lg:w-11/12 mx-auto pt-14 px-3 md:px-10">
      <h1 className="font-bold text-xl md:text-2xl lg:text-3xl">
        Modifier mon mot de passe
      </h1>
      <div className="md:w-96 lg:w-1/2 mt-10 border border-gray-200 rounded-xl shadow-sm px-2 py-4 sm:p-4">
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">Ancien mot de passe</span>
          </label>
          <input
            disabled={loading}
            value={lastPassword}
            onChange={(e) => setLastPassword(e.target.value)}
            type="password"
            placeholder="******"
            className="input w-full bg-gray-mtn"
          />
        </div>
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">Nouveau mot de passe</span>
          </label>
          <input
            disabled={loading}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            type="password"
            placeholder="******"
            className="input w-full bg-gray-mtn"
          />
        </div>
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text">Confirme nouveau mot de passe</span>
          </label>
          <input
            disabled={loading}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
            placeholder="******"
            className="input w-full bg-gray-mtn"
          />
        </div>
        <button
          disabled={loading}
          className="bg-jaune-mtn w-full h-11 text-sm sm:text-base rounded-lg font-bold mt-5 flex items-center justify-center"
          onClick={changePassword}
        >
          {!loading ? (
            "Modifier"
          ) : (
            <ThreeDots
              height="40"
              width="40"
              radius="9"
              color="#000"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={loading}
            />
          )}
        </button>
        {successMessage ? (
          <div className="mt-5 flex justify-center">
            <p className="inline text-green-500 bg-green-100 px-2 text-center font-medium text-sm sm:text-base rounded-sm">
              {successMessage}
            </p>
          </div>
        ) : null}
        {errorMessage ? (
          <div className="mt-5 flex justify-center">
            <p className="inline text-red-500 bg-red-100 px-2 text-center font-medium text-sm sm:text-base rounded-sm">
              {errorMessage}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MotDePasse;
